import { render, staticRenderFns } from "./BulkProductGrid.vue?vue&type=template&id=327f5d0b&scoped=true&"
import script from "./BulkProductGrid.vue?vue&type=script&lang=js&"
export * from "./BulkProductGrid.vue?vue&type=script&lang=js&"
import style0 from "./BulkProductGrid.vue?vue&type=style&index=0&id=327f5d0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327f5d0b",
  null
  
)

export default component.exports